import { LoginContainer } from "views/containers/auth/login-container";

const Login = (): JSX.Element => {
  return <LoginContainer />;
};

export default Login;
